import styled from "styled-components"

const breakpoints = ["28.125em", "48em", "62em"]

export const FooterSection = styled.div`
  padding-top: 2.5rem;
  background: #080a2d;

  ul,
  li {
    list-style-type: none;
  }
`

export const FooterTop = styled.div`
  padding: 1.25rem 3.75rem;
  color: white;
  background: #080a2d;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.5);

  @media (min-width: ${breakpoints[2]}) {
  }
`
export const Logo = styled.div`
  width: 100%;
  margin-bottom: 2.5rem;

  @media (min-width: ${breakpoints[2]}) {
    margin-bottom: 0;
    img {
      height: 90px;
      width: 700px;
    }
  }
`
export const Content = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 2.5rem;

  @media (min-width: ${breakpoints[2]}) {
    flex-direction: row;
  }
`
export const LinkColumns = styled.div`
  nav {
    display: flex;
    justify-content: flex-start;
    margin: 1.875rem 0;
    @media (min-width: ${breakpoints[2]}) {
      margin: 0;
    }

    & > *:first-child {
      margin-right: 7.5rem;
    }
    & > * {
      margin-right: 3.75rem;
    }
  }
`
interface SocialMediaProps {
  mobile?: boolean
}
export const SocialMedia = styled.div<SocialMediaProps>`
  margin-top: 2.2rem;
  a {
    margin-right: 1.6rem;
  }
  display: ${(props: CopyrightProps) => (props.mobile ? "flex" : "none")};

  @media (min-width: ${breakpoints[2]}) {
    display: ${(props: CopyrightProps) => (props.mobile ? "none" : "flex")};
    direction: row;
    justify-content: flex-end;
  }
`

export const FooterBottom = styled.div`
  padding: 1.25rem 3.75rem;
  color: white;
  background: #080a2d;
  font-size: 1rem;
  font-family: 'Acid Grotesk', sans-serif;
  font-weight: 400;
`

export const Contact = styled.div`
  width: 100%;
  margin-top: 2rem;
  opacity: 0.5;
  display: flex;
  a {
    text-decoration: none;
    color: inherit;
  }
  span {
    display: flex;
    align-items: center;
    margin-bottom: 2rem;
    &:first-child {
      margin-right: 4rem;
    }
    & > img {
      height: 18px;
      width: 18px;
      margin-right: 1rem;
    }
  }
  flex-direction: column;
  @media (min-width: ${breakpoints[2]}) {
    flex-direction: row;
    align-items: center;
  }
`
export const Subtitle = styled.div`
  width: 100%;
  margin-top: 1rem;
  opacity: 0.5;

  @media (min-width: ${breakpoints[2]}) {
    width: 50%;
  }
`
export const LinkRow = styled.div`
  width: 100%;
  opacity: 0.5;
  margin-top: 2.4rem;
  display: flex;
  justify-content: space-between;
`

interface CopyrightProps {
  mobile?: boolean
}
export const Copyright = styled.div<CopyrightProps>`
  width: 100%;
  display: ${(props: CopyrightProps) => (props.mobile ? "block" : "none")};
  padding-bottom: 1.6rem;

  @media (min-width: ${breakpoints[2]}) {
    width: ${(props: CopyrightProps) => (props.mobile ? "100%" : "25%")};
    display: ${(props: CopyrightProps) => (props.mobile ? "none" : "block")};
  }
`
export const Links = styled.div`
  spacing: 1.6rem;
  justify-content: flex-end;
  width: 100%;

  display: grid;
  grid-template: auto auto / 1fr 1fr;

  @media (min-width: ${breakpoints[2]}) {
    display: flex;
    width: 55%;
    min-width: 750px;
  }
`
interface LinkItemProps {
  smallScreenWidth?: string
  desktopWidth?: string
}
export const LinkItem = styled.div<LinkItemProps>`
  margin-bottom: 1.6rem;
  width: ${(props: LinkItemProps) => props.smallScreenWidth || "100%"};

  @media (min-width: ${breakpoints[2]}) {
    width: ${(props: LinkItemProps) => props.desktopWidth || "100%"};
  }
`

export const NavSection = styled.article`
  ul {
    list-style-type: none;
    padding: 0;
  }
  a {
    color: white;
  }  
  li {
    font-size: 1.2rem;
    margin-bottom: 14px;
  }
  h3, li {
    font-family: 'Acid Grotesk', sans-serif; 
    font-weight: 400;
  }
`;

export const SubHeadline = styled.div`
  color: #FFF;
  font-family: Acid Grotesk;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 34px;
`

export const ListItem = styled.a`
  font-family: Acid Grotesk;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  text-decoration: none;
  &:hover {
    cursor: pointer;
  }
`